/**
 * Configuration for all tags/badges that can appear on cards (e.g. FundCard).
 *
 * Each entry describes:
 *  - key:     unique id (also used as the React `key`)
 *  - flag:    the prop name on the source object that toggles visibility
 *  - label:   the text shown inside the tag
 *  - variant: visual style, maps to `.c-fund-card__tag--{variant}` in SCSS
 *             (currently: "primary" = yellow pill, "accent" = red square)
 *  - align:   which side of the card the tag anchors to ("left" | "right")
 *
 * To add a new tag in the future, just append an entry here and (if needed)
 * add a matching `--variant` style block in the consuming component's SCSS.
 */
export const FUND_CARD_TAGS = [
  {
    key: "recommended",
    flag: "isRecommended",
    label: "Top Recommended",
    variant: "primary",
    align: "left",
  },
  {
    key: "awardWinning",
    flag: "isAwardWinning",
    label: "Award Winning Fund",
    variant: "primary",
    align: "left",
  },
  {
    key: "popular",
    flag: "isPopular",
    label: "Popular",
    variant: "accent",
    align: "right",
  },
  {
    key: "rebate",
    flag: "isRebateApplicable",
    label: "69% Rebate",
    variant: "accent",
    align: "right",
  },
  {
    key: "gotitan",
    flag: "isGotitanApplicable",
    label: "50%",
    variant: "accent",
    align: "right",
  },
];

/**
 * Given a source object of boolean flags (typically the component props),
 * returns the visible tags grouped by alignment.
 *
 * @param {Record<string, boolean>} flags
 * @param {Array} [config=FUND_CARD_TAGS]
 * @returns {{ left: Array, right: Array, all: Array, hasAny: boolean }}
 */
export const getVisibleTags = (flags = {}, config = FUND_CARD_TAGS) => {
  const all = config.filter(t => Boolean(flags[t.flag]));
  return {
    all,
    left: all.filter(t => t.align === "left"),
    right: all.filter(t => t.align === "right"),
    hasAny: all.length > 0,
  };
};
